/*
 * SPDX-FileCopyrightText: 2021 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import type { OptionalCommentState, CommentActions } from './types';
import { CommentActionType } from './types';
import type { Reducer } from 'redux';

export const CommentReducer: Reducer<OptionalCommentState, CommentActions> = (
  state: OptionalCommentState = {
    comments: [],
    positions: [],
    hiddenCommentBox: true,
    hiddenCommentButton: true,
    hiddenCommentList: true,
    commentButtonPosition: {
      position: 'absolute',
      left: '0',
      top: '0',
      heightInPixel: 28,
      widthInPixel: 70
    },
    selectedRange: null,
    prevMarkdown: '',
    prevSelection: {},
    replies: [],
    count: 0
  },
  action: CommentActions
) => {
  let newState;
  switch (action.type) {
    case CommentActionType.CREATE_COMMENT:
      return {
        ...state,
        comments: [...state.comments, ...action.state],
        count: state.count + 1
      };
    case CommentActionType.SET_COMMENTS_POSITION:
      newState = {
        ...state,
        positions: action.state
      };
      return newState;
    case CommentActionType.APPEND_COMMENT_POSITION:
      newState = [...state.positions, action.state];
      return {
        ...state,
        positions: newState.sort(
          (post1, post2) => post1.attributes.anchor - post2.attributes.anchor
        )
      };
    case CommentActionType.UPDATE_SHOW_COMMENT_BUTTON:
      return {
        ...state,
        hiddenCommentButton: action.state
      };
    case CommentActionType.UPDATE_SHOW_COMMENT_BOX:
      return {
        ...state,
        hiddenCommentBox: action.state
      };
    case CommentActionType.UPDATE_SHOW_COMMENT_LIST:
      return {
        ...state,
        hiddenCommentList: action.state
      };
    case CommentActionType.UPDATE_COMMENT:
      return {
        ...state,
        comments: action.state
      };
    case CommentActionType.UPDATE_COMMENT_REPLIES:
      return {
        ...state,
        replies: action.state
      };
    case CommentActionType.UPDATE_COMMENT_BUTTON_POSITION:
      const { heightInPixel, widthInPixel } = state.commentButtonPosition;
      const computedLeft =
        action.state.left + action.state.width / 2 - widthInPixel / 2;
      const computedTop = window.scrollY + action.state.top - heightInPixel;

      return {
        ...state,
        commentButtonPosition: {
          ...state.commentButtonPosition,
          left: computedLeft,
          top: computedTop
        }
      };
    case CommentActionType.UPDATE_SELECTED_RANGE:
      return {
        ...state,
        selectedRange: action.state
      };
    case CommentActionType.UPDATE_COMMENT_POSITION_ON_CHANGE:
      return {
        ...state,
        positions: action.state
      };
    case CommentActionType.UPDATE_PREV_TEXT_AND_SELECTION:
      return {
        ...state,
        prevMarkdown: action.state.plain,
        prevSelection: action.state.selection
      };
    case CommentActionType.UPDATE_COMMENT_COUNT:
      return {
        ...state,
        count: action.count
      };
    default:
      return state;
  }
};
